var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("edit-heatmap-or-grid-data", {
        attrs: { elementData: this.attributes },
        on: { submit: _vm.handleSubmit, cancel: _vm.close },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /opt/HistomicsUI/histomicsui/web_client/~/vue-loader/lib/loaders/templateLoader.js?{}!/opt/HistomicsUI/histomicsui/web_client/~/vue-loader/lib?{}!./~/@girder/histomicsui/vue/components/EditHeatmapOrGridDataContainer.vue?vue&type=template&id=8c11edd6&
// module id = 69
// module chunks = 0